<template>
  <div class="filiale">
    <h1>分公司办事处</h1>
    <div class="main">
      <div class="content" v-for="item in branchOffice" :key="item.address">
        <div class="cnResult">
          {{ item.officename }}
        </div>
        <div class="cnResult">
          地址：{{ item.address }}
        </div>
        <div class="cnResult">
          邮编：{{ item.post }}
        </div>
        <div class="cnResult">
          联系人：{{ item.contacts }}
        </div>
        <div class="cnResult">
          电话：{{ item.phone }}
        </div>
        <div class="cnResult">
          传真：{{ item.fax }}
        </div>
        <div class="cnResult">
          <a :href="`mailto:${item.email}`">
            邮箱：{{item.email}}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postDetail, postAbout } from "@/api/company";

export default {
  name: "filiale",
  data() {
    return {
      branchOffice: []
    };
  },
  mounted() {
    const webName = this.$router.history.current.params.name;
    this.postDetail(webName);
  },
  methods: {
    // 详情
    postDetail(name) {
      postDetail({
        web_name: name,
      }).then((res) => {
        this.postAbout(res.data.organ_id);
      });
    },
    // 关于我们
    postAbout(id) {
      postAbout({
        organCode: id,
      }).then((res) => {
        this.branchOffice = res.data.branch_office
        console.log("关于我们", res.data.branch_office);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>